import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hasLineItemsInOrderSelected } from '../../../../../../selectors/tools';
import { processRemotelyForRefund } from '../../../../../../actions/tools/DecisionTree/CancellationActions';
import { DTOrderSearchView } from '../../DTOrderSearchView';
import { selectSearchPageLoading } from '../../../../../../selectors/searchPage';
import { CustomNoResultsComponentContextProvider } from '../../Common/NoSearchResults/CustomNoResultsComponentContext';
import { DTNoResultsLink } from '../../../../Common/DTNoResultsLink/DTNoResultsLink';

const DTSelectItemsForRefundProcessing = () => {
  const dispatch = useDispatch();
  const hasLineItemsSelected = useSelector(hasLineItemsInOrderSelected);
  const isLoading = useSelector(selectSearchPageLoading);

  const handleNextButtonClick = () => {
    dispatch(processRemotelyForRefund());
  };

  return (
    <CustomNoResultsComponentContextProvider value={<DTNoResultsLink />}>
      <DTOrderSearchView
        onNextButtonClick={handleNextButtonClick}
        isNextButtonActive={hasLineItemsSelected && !isLoading}
      />
    </CustomNoResultsComponentContextProvider>
  );
};

export default DTSelectItemsForRefundProcessing;
